import React, { useEffect, useState } from 'react';
import CursorTracker from './CursorTracker';
import DraggablePostIt from './DraggablePostit';
import database from './firebaseConfig';
import { ref, get, onValue, set as firebaseSet } from 'firebase/database';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { v4 as uuidv4 } from 'uuid'; // Import UUID to generate unique IDs

const App = () => {

  const addNewPostIt = () => {
    // const newId = uuidv4(); // Generate a unique ID
    // const initialPosition = { x: 100, y: 100 }; // Set an initial position
    // const newPostIts = { ...postIts, [newId]: initialPosition };
    // setPostIts(newPostIts); // Update the local state
    // firebaseSet(ref(database, `postits/${newId}`), initialPosition); // Update the Firebase database
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <CursorTracker />
    </DndProvider>
  );
};

export default App;
